import { ActionTypes } from '../../constants/action-types';
import { SelectOptionWithRateAction, SelectOptionAction } from './types';
import { OptionTypes } from '../../../models/itinerary';

export function selectOption(
  segmentId: number,
  optionId: string,
  isRecommended: boolean = false,
): SelectOptionAction {
  return {
    type: ActionTypes.OPTION_SELECT,
    segmentId,
    optionId,
    isRecommended,
  };
}

export function selectOptionFromRate(
  segmentId: number,
  option: OptionTypes,
  isRecommended: boolean,
): SelectOptionWithRateAction {
  return {
    type: ActionTypes.OPTION_SELECT_WITH_RATE,
    segmentId,
    option,
    isRecommended,
  };
}
